<template>
  <div class="login-root">
    <el-row>
      <el-col :xs="{span: 24, offset: 0}" :sm="{span: 8, offset: 8}">
        <img class="u-img-responsive" src="../../assets/briteappslogonotagline.png"/>

      </el-col>
    </el-row>
    <el-row  >
      <el-col v-if="warning" :xs="{span: 20, offset: 2}" :sm="{span: 8, offset: 8}">
        <div class="u-text--danger">{{warning}}</div>
      </el-col>
      <el-col :xs="{span: 24, offset: 0}" :sm="{span: 8, offset: 8}">
        <el-input @keyup.enter.native="willLogin" class="u-mb2" placeholder="Username or e-mail" v-model="form.username"></el-input>
        <el-input @keyup.enter.native="willLogin" class="u-mb4" type="password" placeholder="Password" v-model="form.password"></el-input>
        <div class="u-text--center">
          <el-button v-loading="loading" @keyup.enter.native="willLogin" @click="willLogin" class="u-mt-4" type="success" >Login</el-button>
        </div>
      </el-col>


    </el-row>
    <footer class="u-text--sm u-pt2">{{version}}</footer>

  </div>

</template>

<script>

/* eslint-disable */
import axios from 'axios'

import BaHeader from '@/components/header.component.vue'
import {mapMutations, mapActions, mapState} from 'vuex'

export default {
  components: {BaHeader},
  name: 'ba-login-page',
  data () {
    return {
      form: {
        username: '',
        password: '',
      },
      loading: false,
      warning: null,
    }
  },
  computed: {
    ...mapState('shared', ['version']),
  },
  methods: {
    ...mapActions('login', ['auth']),
    willLogin () {
      this.loading = true
      this.warning = null
      let promise
      this.auth(this.form)
        .then(this.didReceiveLoginResponse.bind(this))
        .catch(this.loginDidFail)
        .then(() => this.loading = false)
    },
    loginDidFail (response) {
      if (response && response.data && response.data.messages && response.data.messages.length > 0) {
        this.warning = response.data.messages[0]
      } else {
        this.warning = "Error while logging in..."
      }

    },

    didReceiveLoginResponse (result) {
      console.log('login', result)
      let response = result.data
      if (!response.success) {
        this.loginErrorClass = 'login__error--will-show'
        let message = ''
        if (response.errors && response.errors.length) {
          message = 'Error: ' + response.errors[0]
        } else {
          message = 'Error: general error occurred'
        }
        this.loginDidFail(message)
        return
      }
      this.$router.push({name: 'company-select'})
    },

  },
}
</script>
<style scoped lang="scss">
  .login-root {
    min-height: 100%;
  }
  footer {
    position:absolute;
    bottom:0;
    text-align: center;
    background-color: #CFD9DF;
    width:100%;
    height:2em;   /* Height of the footer */
  }
</style>